import React from 'react'
import { t } from 'ttag'

import { getResult, isSuccess, receivedResponse } from '../h2Api'

function APIResponse({ request, onWait, onError, children }) {
  if (!receivedResponse(request)) {
    return onWait?.() ?? t`Retrieving...`
  }

  if (!isSuccess(request)) {
    return onError?.() ?? t`An error occurred`
  }

  return children(getResult(request))
}

export default APIResponse
